export const SearchBarMode = {
    Default: 'default',
    Pro: 'pro',
    LoggedOut: 'logged-out',
    Routing: 'routing',
    QuickActions: 'quick-actions',
};
